import React from 'react';
import { FadeIn } from './FadeIn';
import { Lock, ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="comprar" className="bg-primary-dark text-text-dark py-20 md:py-32 border-t-4 border-accent" data-id="element-121">
      <div className="container mx-auto px-6 max-w-4xl text-center" data-id="element-122">
        <FadeIn data-id="element-123">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white" data-id="element-124">
            Tu paz mental vale mucho más que una salida a comer.
          </h2>
          <p className="text-xl text-text-muted mb-12" data-id="element-125">
            Llevate el manual completo de blindaje laboral hoy mismo.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-126">
          <div className="bg-secondary-dark/80 border border-accent/30 rounded-2xl p-8 md:p-12 max-w-2xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-127">
            <div className="absolute top-0 right-0 bg-accent text-primary-dark font-bold py-1 px-4 rounded-bl-lg text-sm uppercase tracking-wider" data-id="element-128">
              Oferta Especial
            </div>

            <p className="text-text-muted text-lg mb-2" data-id="element-129">
              Precio de lanzamiento:
            </p>
            <div className="flex items-center justify-center gap-1 mb-2" data-id="element-130">
              <span className="text-2xl text-text-muted line-through opacity-60" data-id="element-131">
                $47.999
              </span>
              <span className="text-sm text-text-muted line-through opacity-60" data-id="element-132">
                ARS
              </span>
            </div>
            <div className="flex items-center justify-center gap-2 mb-3" data-id="element-133">
              <span className="text-6xl font-black text-white" data-id="element-134">$8.499</span>
              <span className="text-2xl text-accent font-bold mt-4" data-id="element-135">ARS</span>
            </div>
            <div className="inline-block bg-green-500/20 text-green-400 text-sm font-bold px-4 py-1 rounded-full mb-8" data-id="element-136">
              82% OFF — Solo por tiempo limitado
            </div>

            <a href="https://metodosolido.com/cart/54279937917300:1" target="_blank" rel="noopener noreferrer" className="w-full bg-accent hover:bg-accent/90 text-primary-dark font-bold text-xl py-5 px-8 rounded-xl transition-all duration-300 transform hover:-translate-y-1 shadow-[0_4px_20px_rgba(201,149,62,0.4)] flex flex-col items-center justify-center gap-1 no-underline" data-id="element-137">
              <span data-id="element-138">Quiero mi paz mental de vuelta</span>
            </a>

            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-text-muted" data-id="element-139">
              <div className="flex items-center gap-2" data-id="element-140">
                <Lock size={16} className="text-accent" data-id="element-141" />
                <span data-id="element-142">Pago seguro</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-secondary-dark rounded-full" data-id="element-143"></div>
              <div className="flex items-center gap-2" data-id="element-144">
                <ShieldCheck size={16} className="text-accent" data-id="element-145" />
                <span data-id="element-146">Descarga inmediata</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}